import { createSlice } from "@reduxjs/toolkit";

const errorValidation = createSlice({
  name: "validationScreen",
  initialState: {
    validationError: null,
  },
  reducers: {
    validationMessageError: (state, action) => {
      state.validationError = action.payload;
    },
  },
});

export default errorValidation;
